// extracted by mini-css-extract-plugin
module.exports = {"registerForm":"User_2gA5KHYJ-D","registerContainer":"User_3WSJHY9uoI","mod":"User_3JkFjDNLmQ"};